import React from "react";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { useGetStreamingUrl } from "../../../stepFlowHooks/useGetStreamingUrl";
import log, { METRIC_NAME } from "../../../logging";
import { BrowserCreationErrorModal } from "../../BrowserCreationErrorModal/BrowserCreationErrorModal";
import { useAsyncEffect } from "use-async-effect";

// TODO  [LOWA-30534] From: https://tiny.amazon.com/aed5k04m
export const StreamingUrlSetup = () => {
    const setStreamingUrl = useSessionDataStore(
        (store) => store.setStreamingUrl
    );
    const cookieSyncTarget = useSessionDataStore(
        (store) => store.cookieSyncTarget
    );

    const { getStreamingUrl, error } = useGetStreamingUrl();

    useAsyncEffect(async () => {
        if (cookieSyncTarget == null) {
            return;
        }

        try {
            const endpoint = await getStreamingUrl(cookieSyncTarget);
            setStreamingUrl(endpoint);
        } catch (error) {
            log.publishHttpStatusMetric(
                METRIC_NAME.CREATE_REMOTE_BROWSER,
                error?.$metadata?.httpStatusCode
            );
        }
    }, [cookieSyncTarget]);

    if (error != null) {
        return <BrowserCreationErrorModal error={error} />;
    }

    return <></>;
};
